import { BUTTON_COLOR_PATH } from '../constants/wix-params';
import withSettingsColor from './with-settings-color';

export default withSettingsColor(BUTTON_COLOR_PATH, 'buttonColor', 'color-8', 1);



// WEBPACK FOOTER //
// ./app/hoc/with-button-color.js